import axiosInstance from "../axios-interceptor";
import { AppSettings } from "../constant";

const { Ewaste } = AppSettings;

export const updateEwasteStatus = async (ids, assetType, eWasteStatus) => {
  const res = await axiosInstance.post(Ewaste.updateEwasteStatus, {
    ids,
    assetType,
    eWasteStatus,
  });
  return res.data;
};

export const moveToEwaste = async (id, assetType) => {
  const res = await axiosInstance.post(Ewaste.moveToEwaste, {
    ids: [id],
    assetType,
  });
  return res.data;
};

export const createEwasteRequest = async (ids, assetType, role) => {
  const res = await axiosInstance.post(Ewaste.createEwasteRequest, {
    ids: Array.isArray(ids) ? ids : [ids],
    assetType,
    role,
  });
  return res.data;
};
export const getEwasteAssetList = async (payload) => {
  const res = await axiosInstance.post(Ewaste.getEwasteAssetList, payload);
  return res?.data;
};

export const eWasteStatus = async () => {
  const res = await axiosInstance.get(Ewaste.eWasteStatus);
  return res.data?.response?.statuses || [];
};